;
(function (ng) {
  'use strict';

  angular.module('validation', []);
})(window.angular);